import React from "react";
import styles from "./CartSkeleton.module.css";

const CartSkeleton: React.FC = () => {
  return (
    <div className="container">
      <div className={styles.cartContainer}>
        <div className={styles.pageTitleSkeleton}></div>

        <div className={styles.cartMain}>
          <div className={styles.cartContent}>
            {/* Location info skeleton */}
            <div className={styles.locationInfoSkeleton}></div>

            {/* Cart group skeletons - create multiple groups */}
            {[...Array(2)].map((_, groupIndex) => (
              <div key={groupIndex} className={styles.cartGroupSkeleton}>
                {/* Group header */}
                <div className={styles.groupHeaderSkeleton}></div>

                {/* Cart items - 3 items per group */}
                {[...Array(3)].map((_, itemIndex) => (
                  <div key={itemIndex} className={styles.cartItemSkeleton}>
                    <div className={styles.itemImageSkeleton}></div>
                    <div className={styles.itemContentSkeleton}>
                      <div className={styles.itemNameSkeleton}></div>
                      <div className={styles.itemAttributesSkeleton}>
                        <div className={styles.attributeSkeleton}></div>
                        <div className={styles.attributeSkeleton}></div>
                      </div>
                      <div className={styles.itemOptionsSkeleton}>
                        <div className={styles.quantitySelectorSkeleton}></div>
                        <div className={styles.priceSkeleton}></div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Group footer */}
                <div className={styles.groupFooterSkeleton}>
                  <div className={styles.deliveryInfoSkeleton}></div>
                  <div className={styles.subtotalSkeleton}></div>
                </div>
              </div>
            ))}
          </div>

          {/* Cart summary skeleton */}
          <div className={styles.cartSidebar}>
            <div className={styles.cartSummarySkeleton}>
              <div className={styles.summaryTitleSkeleton}></div>
              <div className={styles.summaryRowsSkeleton}>
                {[...Array(3)].map((_, index) => (
                  <div key={index} className={styles.summaryRowSkeleton}></div>
                ))}
              </div>
              <div className={styles.totalRowSkeleton}></div>
              <div className={styles.checkoutButtonSkeleton}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;
